// import React, { useState, useEffect } from 'react';
// import { useSelector, useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
// import { Get_Managers, Update_Manager, Create_Manager, Delete_Manager, Set_Password } from '../../../services/oprations/Manager';
// import StandardSpinner from '../../../utils/Spinner';
// import { useToast } from '../../Toast';
// import { KeyRound, Eye, EyeOff, ChevronDown, ChevronUp, Key, Edit2, Trash2, MoreVertical, Check as CheckIcon, Loader2, Filter } from 'lucide-react';

// // ─── Validation Rules ─────────────────────────────────────────────────────────
// const ALPHA_ONLY = /^[a-zA-Z\s]+$/;
// const ALPHANUM   = /^[a-zA-Z0-9!@#$%^&*]+$/;
// const EMAIL_RE   = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
// const MOBILE_RE  = /^[0-9]{10}$/;

// const validateAddForm = (data) => {
//   const errors = {};
//   if (!data.manager_name.trim()) errors.manager_name = 'Name is required';
//   else if (!ALPHA_ONLY.test(data.manager_name.trim())) errors.manager_name = 'Name must contain letters only';
//   if (!data.manager_email.trim()) errors.manager_email = 'Email is required';
//   else if (!EMAIL_RE.test(data.manager_email.trim())) errors.manager_email = 'Enter a valid email (name@domain.com)';
//   if (!data.phone_number?.trim()) errors.phone_number = 'Mobile number is required';
//   else if (!MOBILE_RE.test(data.phone_number.trim())) errors.phone_number = 'Enter a valid 10 digit mobile number';
//   if (!data.manager_password) errors.manager_password = 'Password is required';
//   else if (data.manager_password.length < 6) errors.manager_password = 'Password must be at least 6 characters';
//   else if (!ALPHANUM.test(data.manager_password)) errors.manager_password = 'Password must be alphanumeric';
//   if (!data.department.trim()) errors.department = 'Department is required';
//   else if (!ALPHA_ONLY.test(data.department.trim())) errors.department = 'Department must contain letters only';
//   return errors;
// };

// const validateEditForm = (data) => {
//   const errors = {};
//   if (!data.manager_name.trim()) errors.manager_name = 'Name is required';
//   else if (!ALPHA_ONLY.test(data.manager_name.trim())) errors.manager_name = 'Name must contain letters only';
//   if (!data.manager_email.trim()) errors.manager_email = 'Email is required';
//   else if (!EMAIL_RE.test(data.manager_email.trim())) errors.manager_email = 'Enter a valid email (name@domain.com)';
//   if (!data.phone_number?.trim()) errors.phone_number = 'Mobile number is required';
//   else if (!MOBILE_RE.test(data.phone_number.trim())) errors.phone_number = 'Enter a valid 10 digit mobile number';
//   if (!data.department.trim()) errors.department = 'Department is required';
//   else if (!ALPHA_ONLY.test(data.department.trim())) errors.department = 'Department must contain letters only';
//   return errors;
// };

// const FieldError = ({ msg }) => msg ? <p className="mt-1 text-xs text-red-400">{msg}</p> : null;

// const inputCls = (hasError) =>
//   `w-full p-3 text-white bg-black border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 text-sm ${
//     hasError ? 'border-red-500' : 'border-blue-800/60'
//   }`;

// const SpinnerIcon = () => (
//   <svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//     <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
//     <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
//   </svg>
// );

// // Mobile manager card with checkbox
// const ManagerCard = ({ manager, onEdit, onDelete, onSetPassword, onStatusChange, getStatusBadge, isSelected, onSelect }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <div className={`p-4 space-y-3 border rounded-xl transition-colors ${
//       isSelected 
//         ? 'bg-red-900/15 border-red-700/50' 
//         : 'bg-richblue-800/20 border-blue-700/80'
//     }`}>
//       {/* Top row with checkbox */}
//       <div className="flex items-start justify-between gap-2">
//         <div className="flex items-center min-w-0 gap-3">
//           <input
//             type="checkbox"
//             checked={isSelected}
//             onChange={(e) => onSelect(e, manager._id)}
//             onClick={(e) => e.stopPropagation()}
//             className="flex-shrink-0 w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//           />
//           <div className="flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//             {manager.manager_name?.charAt(0) || 'M'}
//           </div>
//           <div className="min-w-0">
//             <p className="text-sm font-semibold text-white truncate">{manager.manager_name}</p>
//             <p className="text-xs truncate text-blue-300/70">{manager.manager_email}</p>
//           </div>
//         </div>
//         <span className={`px-2 py-0.5 rounded-full text-xs font-semibold capitalize flex-shrink-0 ${getStatusBadge(manager.status)}`}>
//           {manager.status ? 'active' : 'inactive'}
//         </span>
//       </div>

//       {/* Expand toggle */}
//       <button
//         onClick={() => setOpen(o => !o)}
//         className="flex items-center gap-1 text-xs text-blue-400 hover:text-blue-300"
//       >
//         {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
//         {open ? 'Less info' : 'More info'}
//       </button>

//       {open && (
//         <div className="grid grid-cols-2 gap-2 text-xs">
//           <div>
//             <p className="text-blue-400">Phone</p>
//             <p className="text-white">{manager.phone_number}</p>
//           </div>
//           <div>
//             <p className="text-blue-400">Role</p>
//             <p className="text-white">{manager.role}</p>
//           </div>
//           <div>
//             <p className="text-blue-400">Department</p>
//             <p className="text-white">{manager.department || 'Unknown'}</p>
//           </div>
//         </div>
//       )}

//       {/* Actions */}
//       <div className="flex items-center gap-2 pt-1 border-t border-blue-800/40">
//         <button onClick={() => onEdit(manager)}
//           className="p-1.5 text-blue-300 border rounded-lg bg-blue-600/20 hover:bg-blue-600/30 border-blue-700/50">
//           <Edit2 className="w-3.5 h-3.5" />
//         </button>
//         <button onClick={() => onSetPassword(manager)}
//           className="p-1.5 text-yellow-300 border rounded-lg bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50">
//           <Key className="w-3.5 h-3.5" /> 
//         </button>
//         <button onClick={() => onDelete(manager)}
//           className="p-1.5 text-red-300 border rounded-lg bg-red-600/20 hover:bg-red-600/30 border-red-700/50">
//           <Trash2 className="w-3.5 h-3.5" />
//         </button>
//         <button onClick={() => onStatusChange(manager._id, !manager.status)}
//           className={`flex-1 flex items-center justify-center px-2 py-1.5 text-xs font-medium border rounded-lg transition-colors ${
//             manager.status
//               ? 'text-yellow-300 bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50'
//               : 'text-green-300 bg-green-600/20 hover:bg-green-600/30 border-green-700/50'
//           }`}>
//           {manager.status ? 'Deactivate' : 'Activate'}
//         </button>
//       </div>
//     </div>
//   );
// };

// // ─── Main Component ───────────────────────────────────────────────────────────
// const ManagerManagement = () => {
//   const toast = useToast();
//   const { managers } = useSelector((state) => state.manager);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const managersData = typeof managers === 'string' ? JSON.parse(managers) : managers;

//   const [selectedManager, setSelectedManager] = useState(null);
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [isAddModalOpen, setIsAddModalOpen] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // ── Multi-select / bulk delete ──────────────────────────────────────────
//   const [selectedIds, setSelectedIds] = useState(new Set());
//   const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
//   const [isBulkDeleting, setIsBulkDeleting] = useState(false);
//   const [bulkProgress, setBulkProgress] = useState({ current: 0, total: 0 });

//   const [isSetPasswordModalOpen, setIsSetPasswordModalOpen] = useState(false);
//   const [managerForPassword, setManagerForPassword] = useState(null);
//   const [newPassword, setNewPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [isSettingPassword, setIsSettingPassword] = useState(false);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterStatus, setFilterStatus] = useState('all');
//   const [filterDepartment, setFilterDepartment] = useState('all');
//   const [filtersOpen, setFiltersOpen] = useState(false);

//   const [addErrors, setAddErrors] = useState({});
//   const [editErrors, setEditErrors] = useState({});

//   const [editFormData, setEditFormData] = useState({
//     _id: '', manager_name: '', manager_email: '', phone_number: '', role: '', department: '', status: true
//   });
//   const [addFormData, setAddFormData] = useState({
//     manager_name: '', manager_email: '', phone_number: '', manager_password: '', department: '', role: 'Manager', status: true
//   });

//   useEffect(() => { setTimeout(() => setLoading(false), 800); }, []);

//   // ── Helper: Sort managers alphabetically by name ──────────────────────────
//   const sortManagersAlphabetically = (managerArray) => {
//     if (!managerArray || !Array.isArray(managerArray)) return [];
//     return [...managerArray].sort((a, b) => {
//       const nameA = (a.manager_name || '').toLowerCase();
//       const nameB = (b.manager_name || '').toLowerCase();
//       return nameA.localeCompare(nameB);
//     });
//   };

//   // Apply sorting to managers data
//   const sortedManagers = sortManagersAlphabetically(managersData);

//   const departments = ['all', ...new Set(sortedManagers?.map(m => m.department) || [])];

//   // Apply filters to SORTED managers
//   const filteredManagers = sortedManagers?.filter(manager => {
//     const matchesSearch =
//       manager.manager_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       manager.manager_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//       manager.department?.toLowerCase().includes(searchTerm.toLowerCase());
//     let matchesStatus = true;
//     if (filterStatus === 'ACTIVE') matchesStatus = manager.status === true;
//     else if (filterStatus === 'DEACTIVE') matchesStatus = manager.status === false;
//     const matchesDepartment = filterDepartment === 'all' || manager.department === filterDepartment;
//     return matchesSearch && matchesStatus && matchesDepartment;
//   }) || [];

//   // ── Selection helpers ───────────────────────────────────────────────────
//   const allFilteredSelected = filteredManagers.length > 0 && filteredManagers.every(m => selectedIds.has(m._id));
//   const someSelected = selectedIds.size > 0;

//   const toggleSelectAll = () => {
//     if (allFilteredSelected) {
//       setSelectedIds(prev => {
//         const next = new Set(prev);
//         filteredManagers.forEach(m => next.delete(m._id));
//         return next;
//       });
//     } else {
//       setSelectedIds(prev => {
//         const next = new Set(prev);
//         filteredManagers.forEach(m => next.add(m._id));
//         return next;
//       });
//     }
//   };

//   const toggleSelectManager = (e, managerId) => {
//     e.stopPropagation();
//     setSelectedIds(prev => {
//       const next = new Set(prev);
//       next.has(managerId) ? next.delete(managerId) : next.add(managerId);
//       return next;
//     });
//   };

//   const clearSelection = () => setSelectedIds(new Set());

//   // ── Bulk delete ─────────────────────────────────────────────────────────
//   const handleBulkDeleteConfirm = async () => {
//     const ids = [...selectedIds];
//     setIsBulkDeleting(true);
//     setBulkProgress({ current: 0, total: ids.length });

//     let successCount = 0;
//     let errorCount = 0;

//     for (let i = 0; i < ids.length; i++) {
//       setBulkProgress({ current: i + 1, total: ids.length });
//       try {
//         const res = await dispatch(Delete_Manager(ids[i]));
//         if (res?.data?.success) successCount++;
//         else errorCount++;
//       } catch {
//         errorCount++;
//       }
//     }

//     if (successCount > 0) toast.success(`Deleted ${successCount} manager${successCount > 1 ? 's' : ''}${errorCount > 0 ? `, ${errorCount} failed` : ''} successfully`);
//     if (errorCount > 0 && successCount === 0) toast.error(`Failed to delete ${errorCount} manager${errorCount > 1 ? 's' : ''}`);

//     setIsBulkDeleting(false);
//     setIsBulkDeleteOpen(false);
//     setBulkProgress({ current: 0, total: 0 });
//     clearSelection();
//   };

//   const handleAddChange = (field, value) => {
//     setAddFormData(prev => ({ ...prev, [field]: value }));
//     if (addErrors[field]) setAddErrors(prev => ({ ...prev, [field]: '' }));
//   };
//   const handleEditChange = (field, value) => {
//     setEditFormData(prev => ({ ...prev, [field]: value }));
//     if (editErrors[field]) setEditErrors(prev => ({ ...prev, [field]: '' }));
//   };
//   const blockNonAlpha = (e) => {
//     const allowed = /^[a-zA-Z\s]$/;
//     if (!allowed.test(e.key) && !['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'].includes(e.key)) e.preventDefault();
//   };
//   const handleStatusChange = (managerId, newStatus) => dispatch(Update_Manager({ status: newStatus }, managerId));

//   const handleEditClick = (manager) => {
//     setSelectedManager(manager);
//     setEditErrors({});
//     setEditFormData({
//       _id: manager._id, manager_name: manager.manager_name, manager_email: manager.manager_email,
//       phone_number: manager.phone_number, role: manager.role, department: manager.department || '', status: manager.status
//     });
//     setIsEditModalOpen(true);
//   };
//   const handleAddClick = () => {
//     setAddErrors({});
//     setAddFormData({ manager_name: '', manager_email: '', phone_number: '', manager_password: '', department: '', role: 'Manager', status: true });
//     setIsAddModalOpen(true);
//   };
//   const handleSetPasswordClick = (manager) => {
//     setManagerForPassword(manager); setNewPassword(''); setShowPassword(false); setIsSetPasswordModalOpen(true);
//   };
//   const handleSetPasswordSubmit = async (e) => {
//     e.preventDefault();
//     if (!managerForPassword || !newPassword.trim()) return;
//     setIsSettingPassword(true);
//     try {
//       const res = await dispatch(Set_Password(managerForPassword._id, newPassword));
//       if (res.data.success) toast.success(res.data.message || 'Password updated successfully');
//       else toast.error(res.data.message || 'Error updating password');
//     } finally {
//       setIsSettingPassword(false); setIsSetPasswordModalOpen(false);
//       setManagerForPassword(null); setNewPassword('');
//     }
//   };
//   const closeSetPasswordModal = () => {
//     if (isSettingPassword) return;
//     setIsSetPasswordModalOpen(false); setManagerForPassword(null); setNewPassword(''); setShowPassword(false);
//   };
//   const handleEditSubmit = async (e) => {
//     e.preventDefault();
//     const errs = validateEditForm(editFormData);
//     if (Object.keys(errs).length > 0) { setEditErrors(errs); return; }
//     setIsSubmitting(true);
//     try {
//       const res = await dispatch(Update_Manager(editFormData, editFormData._id));
//       setIsEditModalOpen(false); setSelectedManager(null);
//       if (res?.data?.success) toast.success(res.data.message || 'Manager updated successfully');
//       else toast.error(res?.data?.message || 'Error updating manager');
//     } catch { toast.error('Unexpected error occurred'); }
//     finally { setIsSubmitting(false); }
//   };
//   const handleAddSubmit = async (e) => {
//     e.preventDefault();
//     const errs = validateAddForm(addFormData);
//     if (Object.keys(errs).length > 0) { setAddErrors(errs); return; }
//     setIsSubmitting(true);
//     try {
//       const res = await dispatch(Create_Manager(addFormData));
//       setIsAddModalOpen(false);
//       if (res?.data?.success) toast.success(res.data.message || 'Manager created successfully');
//       else toast.error(res?.data?.message || 'Error creating manager');
//       setAddFormData({ manager_name: '', manager_email: '', phone_number: '', manager_password: '', department: '', role: 'Manager', status: true });
//     } catch { toast.error('Unexpected error occurred'); }
//     finally { setIsSubmitting(false); }
//   };
//   const handleDeleteClick = (manager) => { setSelectedManager(manager); setIsDeleteModalOpen(true); };
//   const handleDeleteConfirm = async () => {
//     setIsSubmitting(true);
//     try {
//       const res = await dispatch(Delete_Manager(selectedManager._id));
//       setIsDeleteModalOpen(false); setSelectedManager(null);
//       if (res?.data?.success) toast.success(res.data.message || 'Manager deleted successfully');
//       else toast.error(res?.data?.message || 'Error deleting manager');
//     } catch { toast.error('Unexpected error occurred'); }
//     finally { setIsSubmitting(false); }
//   };

//   const getStatusBadge = (status) =>
//     status ? 'bg-green-900/50 text-green-300 border border-green-700/50'
//            : 'bg-red-900/50 text-red-300 border border-red-700/50';

//   if (loading) return <StandardSpinner />;

//   return (
//     <div className="flex flex-col h-full font-sans text-white bg-richblue-950">
//       <div className="flex-none p-3 sm:p-4 bg-richblue-950">

//         {/* Header */}
//         <div className="flex flex-wrap items-center justify-between gap-3 mb-3 sm:mb-5">
//           <div>
//             <h1 className="text-xl font-bold text-transparent sm:text-3xl bg-gradient-to-r from-blue-200 to-blue-400 bg-clip-text">
//               Manager Management
//             </h1>
//             <p className="mt-1 text-xs sm:text-sm text-blue-400/80">Manage all managers and their permissions</p>
//           </div>
//           <button onClick={handleAddClick}
//             className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-white transition-all duration-200 border rounded-lg sm:px-4 bg-gradient-to-r from-blue-700 to-blue-900 hover:from-blue-600 hover:to-blue-800 border-blue-500/30 hover:scale-105">
//             <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
//               <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
//             </svg>
//             <span className="whitespace-nowrap">Add Manager</span>
//           </button>
//         </div>

//         {/* Stats — using sortedManagers for accurate counts */}
//         <div className="grid grid-cols-2 gap-2 mb-3 sm:gap-3 sm:mb-5 md:grid-cols-4">
//           {[
//             { label: 'Total Managers',    value: sortedManagers.length,                              color: 'text-white'     },
//             { label: 'Active',            value: sortedManagers.filter(m => m.status).length,        color: 'text-green-400' },
//             { label: 'Inactive',          value: sortedManagers.filter(m => !m.status).length,       color: 'text-red-400'   },
//             { label: 'Departments',       value: new Set(sortedManagers.map(m => m.department)).size, color: 'text-blue-300'  },
//           ].map(({ label, value, color }) => (
//             <div key={label} className="p-3 border sm:p-4 bg-richblue-600/20 border-blue-700/80 rounded-xl">
//               <p className="text-xs text-blue-300 truncate">{label}</p>
//               <p className={`mt-1 text-xl sm:text-2xl font-bold ${color}`}>{value}</p>
//             </div>
//           ))}
//         </div>

//         {/* Search + Filters */}
//         <div className="space-y-2">
//           {/* Search bar — always visible */}
//           <div className="flex gap-2">
//             <div className="relative flex-1">
//               <input
//                 type="text"
//                 placeholder="Search by name, email or department..."
//                 value={searchTerm}
//                 onChange={(e) => setSearchTerm(e.target.value)}
//                 className="w-full py-2 pl-10 pr-4 text-sm text-white border rounded-lg bg-richblue-600/20 border-blue-700/80 placeholder-blue-400/40 focus:outline-none focus:ring-2 focus:ring-blue-700"
//               />
//               <svg className="absolute left-3 top-2.5 h-4 w-4 text-blue-400/60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
//               </svg>
//             </div>
//             {/* Filter toggle on mobile */}
//             <button
//               onClick={() => setFiltersOpen(o => !o)}
//               className="flex items-center gap-1 px-3 py-2 text-xs text-blue-300 border rounded-lg md:hidden bg-richblue-600/20 border-blue-700/80"
//             >
//               {filtersOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
//               Filters
//             </button>
//           </div>

//           {/* Filter dropdowns — always visible on md+, toggleable on mobile */}
//           <div className={`${filtersOpen ? 'flex' : 'hidden'} md:flex flex-col sm:flex-row gap-2`}>
//             <select
//               value={filterStatus}
//               onChange={(e) => setFilterStatus(e.target.value)}
//               className="flex-1 px-4 py-2 text-sm text-white border rounded-lg bg-richblue-600/20 border-blue-700/80 focus:outline-none focus:ring-2 focus:ring-blue-700"
//             >
//               <option value="all">All Status</option>
//               <option value="ACTIVE">Active</option>
//               <option value="DEACTIVE">Deactive</option>
//             </select>
//             <select
//               value={filterDepartment}
//               onChange={(e) => setFilterDepartment(e.target.value)}
//               className="flex-1 px-4 py-2 text-sm text-white border rounded-lg bg-richblue-600/20 border-blue-700/80 focus:outline-none focus:ring-2 focus:ring-blue-700"
//             >
//               {departments.map(dept => (
//                 <option key={dept} value={dept}>{dept === 'all' ? 'All Departments' : dept}</option>
//               ))}
//             </select>
//           </div>
//         </div>
//       </div>

//       {/* ── BULK ACTION BAR (appears when items are selected) ─────────── */}
//       {someSelected && (
//         <div className="flex items-center justify-between gap-3 px-3 py-2.5 mx-3 sm:mx-4 mb-2 rounded-xl border border-red-700/50 bg-red-900/20">
//           <div className="flex items-center gap-2 text-sm text-red-300">
//             <CheckIcon className="w-4 h-4" />
//             <span className="font-medium">{selectedIds.size} manager{selectedIds.size > 1 ? 's' : ''} selected</span>
//           </div>
//           <div className="flex items-center gap-2">
//             <button
//               onClick={clearSelection}
//               className="px-3 py-1.5 text-xs text-blue-100 border rounded-lg border-blue-400/80 hover:bg-blue-800/30 transition-colors"
//             >
//               Clear
//             </button>
//             <button
//               onClick={() => setIsBulkDeleteOpen(true)}
//               className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors"
//             >
//               <Trash2 className="w-3.5 h-3.5" />
//               Delete Selected
//             </button>
//           </div>
//         </div>
//       )}

//       {/* Content */}
//       <div className="flex-1 px-3 pb-4 sm:px-4">

//         {/* Mobile: card list (hidden on md+) */}
//         <div className="space-y-3 md:hidden">
//           {/* Mobile select-all bar */}
//           {filteredManagers.length > 0 && (
//             <div className="flex items-center justify-between px-1">
//               <label className="flex items-center gap-2 text-xs text-blue-300 cursor-pointer select-none" onClick={toggleSelectAll}>
//                 <input
//                   type="checkbox"
//                   checked={allFilteredSelected}
//                   onChange={toggleSelectAll}
//                   className="w-4 h-4 text-red-500 border-blue-700 rounded bg-richblue-900 focus:ring-red-600/50"
//                 />
//                 Select all ({filteredManagers.length})
//               </label>
//             </div>
//           )}
          
//           {filteredManagers.length > 0 ? (
//             filteredManagers.map(manager => (
//               <ManagerCard
//                 key={manager._id}
//                 manager={manager}
//                 onEdit={handleEditClick}
//                 onDelete={handleDeleteClick}
//                 onSetPassword={handleSetPasswordClick}
//                 onStatusChange={handleStatusChange}
//                 getStatusBadge={getStatusBadge}
//                 isSelected={selectedIds.has(manager._id)}
//                 onSelect={toggleSelectManager}
//               />
//             ))
//           ) : (
//             <p className="py-8 text-sm text-center text-blue-400/60">No managers found matching your criteria</p>
//           )}
//         </div>

//         {/* Desktop: table (hidden on mobile) */}
//         <div className="hidden border shadow-xl md:block bg-richblue-800/20 border-blue-700/80 rounded-xl shadow-blue-800/60">
//           <div className="overflow-y-auto overflow-x-auto max-h-[500px] rounded-xl">
//             <table className="w-full text-left border-collapse">
//               <thead className="sticky top-0 z-10 bg-richblue-950">
//                 <tr className="border-b border-blue-800/60">
//                   {/* Select-all checkbox column */}
//                   <th className="w-10 p-3">
//                     <input
//                       type="checkbox"
//                       checked={allFilteredSelected}
//                       onChange={toggleSelectAll}
//                       className="w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//                     />
//                   </th>
//                   {['Manager','Email','Phone No.','Role','Department','Status','Actions'].map((h, i) => (
//                     <th key={h} className={`p-4 font-semibold text-sm text-blue-300 whitespace-nowrap border-b border-blue-800/60 bg-richblue-950`}>
//                       {h}
//                     </th>
//                   ))}
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredManagers.length > 0 ? (
//                   filteredManagers.map((manager) => {
//                     const isSelected = selectedIds.has(manager._id);
//                     return (
//                       <tr key={manager._id} className={`transition-colors group hover:bg-blue-950/30 ${isSelected ? 'bg-red-900/10' : ''}`}>
//                         <td className="p-3 border-b border-blue-900/30">
//                           <input
//                             type="checkbox"
//                             checked={isSelected}
//                             onChange={(e) => toggleSelectManager(e, manager._id)}
//                             onClick={(e) => e.stopPropagation()}
//                             className="w-4 h-4 text-red-500 border-blue-700 rounded cursor-pointer bg-richblue-900 focus:ring-red-600/50"
//                           />
//                         </td>
//                         <td className="p-4 border-b border-blue-900/30">
//                           <div className="flex items-center gap-3 whitespace-nowrap">
//                             <div className="flex items-center justify-center flex-shrink-0 font-bold text-white border rounded-full w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//                               {manager.manager_name?.charAt(0) || 'M'}
//                             </div>
//                             <span className="text-sm font-medium text-white">{manager.manager_name}</span>
//                           </div>
//                         </td>
//                         <td className="p-4 text-sm border-b text-blue-300/80 whitespace-nowrap border-blue-900/30">{manager.manager_email}</td>
//                         <td className="p-4 text-sm border-b text-blue-300/80 whitespace-nowrap border-blue-900/30">{manager.phone_number}</td>
//                         <td className="p-4 text-sm text-white border-b whitespace-nowrap border-blue-900/30">{manager.role}</td>
//                         <td className="p-4 text-sm text-gray-400 border-b whitespace-nowrap border-blue-900/30">{manager.department || 'Unknown'}</td>
//                         <td className="p-4 border-b border-blue-900/30">
//                           <span className={`px-2 py-0.5 rounded-full text-xs font-semibold capitalize whitespace-nowrap ${getStatusBadge(manager.status)}`}>
//                             {manager.status ? 'active' : 'inactive'}
//                           </span>
//                         </td>
//                         <td className="p-2 border-b border-blue-900/30">
//                           <div className="flex items-center gap-1.5">
//                             <button onClick={() => handleEditClick(manager)}
//                               className="p-2 text-blue-300 transition-colors border rounded-lg bg-blue-600/20 hover:bg-blue-600/30 border-blue-700/50" title="Edit">
//                               <Edit2 className="w-3.5 h-3.5 text-blue-300" />
//                             </button>
//                             <button onClick={() => handleSetPasswordClick(manager)}
//                               className="p-2 transition-colors border rounded-lg bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50" title="Set Password">
//                               <Key className="w-4 h-4 text-yellow-400" />
//                             </button>
//                             <button onClick={() => handleDeleteClick(manager)}
//                               className="p-2 text-red-300 transition-colors border rounded-lg bg-red-600/20 hover:bg-red-600/30 border-red-700/50" title="Delete">
//                               <Trash2 className="w-3.5 h-3.5 " />
//                             </button>
//                             {manager.status ? (
//                               <button onClick={() => handleStatusChange(manager._id, false)}
//                                 className="px-2 py-1 text-xs font-medium text-yellow-300 transition-colors border rounded-lg bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50 whitespace-nowrap">
//                                 Deactivate
//                               </button>
//                             ) : (
//                               <button onClick={() => handleStatusChange(manager._id, true)}
//                                 className="px-2 py-1 text-xs font-medium text-green-300 transition-colors border rounded-lg bg-green-600/20 hover:bg-green-600/30 border-green-700/50 whitespace-nowrap">
//                                 Activate
//                               </button>
//                             )}
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan="8" className="p-8 text-center text-blue-400/60">No managers found matching your criteria</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>

//       {/* ── BULK DELETE CONFIRMATION MODAL ───────────────────────────── */}
//       {isBulkDeleteOpen && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 bg-black/60 backdrop-blur-sm" onClick={() => !isBulkDeleting && setIsBulkDeleteOpen(false)}>
//           <div className="w-full border sm:max-w-md bg-richblue-950 border-red-700/50 rounded-t-2xl sm:rounded-2xl" onClick={(e) => e.stopPropagation()}>
//             <div className="flex justify-center pt-3 pb-1 sm:hidden">
//               <div className="w-10 h-1 bg-gray-600 rounded-full" />
//             </div>
//             <div className="p-5 space-y-4 sm:p-6">
//               <div className="flex items-start gap-3">
//                 <div className="flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full bg-red-600/20">
//                   <Trash2 className="w-5 h-5 text-red-400" />
//                 </div>
//                 <div>
//                   <h3 className="text-base font-bold text-white">Delete {selectedIds.size} Manager{selectedIds.size > 1 ? 's' : ''}?</h3>
//                   <p className="mt-1 text-sm text-gray-400">
//                     This will permanently delete {selectedIds.size === 1 ? 'the selected manager' : `all ${selectedIds.size} selected managers`}. This action cannot be undone.
//                   </p>
//                 </div>
//               </div>

//               {/* Selected manager names preview */}
//               <div className="p-3 space-y-1 overflow-y-auto border rounded-lg max-h-32 border-red-800/30 bg-red-900/10">
//                 {[...selectedIds].map(id => {
//                   const m = managersData?.find(m => m._id === id);
//                   return m ? (
//                     <div key={id} className="flex items-center gap-2 text-sm">
//                       <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-[10px] font-bold text-white">
//                         {m.manager_name?.charAt(0)}
//                       </div>
//                       <span className="text-white truncate">{m.manager_name}</span>
//                       <span className="flex-shrink-0 ml-auto text-xs text-blue-400/50">{m.manager_email}</span>
//                     </div>
//                   ) : null;
//                 })}
//               </div>

//               {/* Progress bar (shown while deleting) */}
//               {isBulkDeleting && (
//                 <div className="space-y-2">
//                   <div className="flex justify-between text-xs text-blue-300">
//                     <span>Deleting managers...</span>
//                     <span>{bulkProgress.current} / {bulkProgress.total}</span>
//                   </div>
//                   <div className="w-full h-2 rounded-full bg-richblue-900">
//                     <div
//                       className="h-2 transition-all duration-300 bg-red-600 rounded-full"
//                       style={{ width: `${bulkProgress.total > 0 ? (bulkProgress.current / bulkProgress.total) * 100 : 0}%` }}
//                     />
//                   </div>
//                 </div>
//               )}

//               <div className="flex gap-3 pb-2 sm:pb-0">
//                 <button
//                   type="button"
//                   onClick={() => setIsBulkDeleteOpen(false)}
//                   disabled={isBulkDeleting}
//                   className="flex-1 py-2.5 text-sm font-medium text-blue-300 border rounded-lg border-blue-800/60 hover:bg-blue-800/20 transition-colors disabled:opacity-50"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   onClick={handleBulkDeleteConfirm}
//                   disabled={isBulkDeleting}
//                   className="flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
//                 >
//                   {isBulkDeleting
//                     ? <><Loader2 className="w-4 h-4 animate-spin" /> Deleting...</>
//                     : <><Trash2 className="w-4 h-4" /> Delete {selectedIds.size} Manager{selectedIds.size > 1 ? 's' : ''}</>
//                   }
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Set Password Modal ─────────────────────────────────────────────────── */}
//       {isSetPasswordModalOpen && managerForPassword && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm"
//           onClick={closeSetPasswordModal}>
//           <div className="w-full sm:max-w-sm border shadow-2xl bg-richblue-950 border-yellow-700/40 rounded-2xl sm:rounded-2xl shadow-yellow-900/20 mb-[172px] sm:mb-0"
//             onClick={(e) => e.stopPropagation()}>
//             <div className="flex justify-center pt-3 pb-1 sm:hidden">
//               <div className="w-10 h-1 bg-gray-600 rounded-full" />
//             </div>
//             <div className="flex items-center justify-between p-4 border-b sm:p-5 border-blue-800/40">
//               <h3 className="flex items-center gap-2 text-base font-bold text-white sm:text-lg">
//                 <KeyRound className="w-4 h-4 text-yellow-400 sm:w-5 sm:h-5" />
//                 Set Password
//               </h3>
//               <button onClick={closeSetPasswordModal} disabled={isSettingPassword}
//                 className="p-1.5 rounded-lg hover:bg-blue-600/20 transition-colors disabled:opacity-50">
//                 <svg className="w-5 h-5 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                 </svg>
//               </button>
//             </div>
//             <div className="p-4 space-y-4 sm:p-5">
//               <div className="flex items-center gap-3 px-4 py-3 border bg-richblue-900 border-blue-800/40 rounded-xl">
//                 <div className="flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full h-9 w-9 bg-gradient-to-br from-blue-600 to-blue-800 border-blue-400/30">
//                   {managerForPassword.manager_name?.charAt(0) || 'M'}
//                 </div>
//                 <div className="min-w-0">
//                   <p className="text-sm font-medium text-white truncate">{managerForPassword.manager_name}</p>
//                   <p className="text-xs truncate text-blue-400/60">{managerForPassword.manager_email}</p>
//                 </div>
//               </div>
//               <div>
//                 <label className="block mb-2 text-sm font-medium text-blue-300">New Password</label>
//                 <div className="relative">
//                   <input
//                     type={showPassword ? 'text' : 'password'}
//                     value={newPassword}
//                     onChange={(e) => setNewPassword(e.target.value)}
//                     placeholder="Enter new password"
//                     disabled={isSettingPassword}
//                     className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg pl-4 pr-11 py-2.5 text-white placeholder-blue-400/40 focus:outline-none focus:ring-2 focus:ring-yellow-600/60 text-sm disabled:opacity-50"
//                     autoFocus
//                   />
//                   <button type="button" onClick={() => setShowPassword(p => !p)}
//                     className="absolute transition-colors -translate-y-1/2 right-3 top-1/2 text-blue-400/60 hover:text-blue-300">
//                     {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
//                   </button>
//                 </div>
//               </div>
//               <div className="flex gap-3 pt-1 pb-2 sm:pb-0">
//                 <button type="button" onClick={closeSetPasswordModal} disabled={isSettingPassword}
//                   className="flex-1 px-4 py-2.5 rounded-lg border border-blue-800/60 text-blue-300 hover:bg-blue-800/20 transition-colors text-sm font-medium disabled:opacity-50">
//                   Cancel
//                 </button>
//                 <button type="button" onClick={handleSetPasswordSubmit}
//                   disabled={!newPassword.trim() || isSettingPassword}
//                   className="flex-1 px-4 py-2.5 rounded-lg bg-yellow-600 hover:bg-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2">
//                   {isSettingPassword ? <><SpinnerIcon />Updating...</> : <><KeyRound className="w-4 h-4" />Set Password</>}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Add Manager Modal ──────────────────────────────────────────────────── */}
//       {isAddModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm"
//           onClick={() => !isSubmitting && setIsAddModalOpen(false)}>
//           <div className="w-full sm:max-w-2xl border bg-richblue-950 border-blue-700/50 rounded-t-2xl sm:rounded-2xl max-h-[calc(100dvh-72px)] sm:max-h-[92vh] overflow-y-auto mb-[72px] sm:mb-0"
//             onClick={(e) => e.stopPropagation()}>
//             <div className="flex justify-center pt-3 pb-1 sm:hidden">
//               <div className="w-10 h-1 bg-gray-600 rounded-full" />
//             </div>
//             <div className="p-5 sm:p-8">
//               <h3 className="flex items-center gap-2 mb-5 text-lg font-bold text-white sm:mb-6 sm:text-2xl">
//                 <svg className="w-5 h-5 text-blue-500 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
//                 </svg>
//                 Add New Manager
//               </h3>
//               <form onSubmit={handleAddSubmit} className="space-y-4" noValidate>
//                 <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
//                   <div>
//                     <label className="block mb-2 text-sm font-medium text-blue-300">Full Name <span className="text-red-400">*</span></label>
//                     <input type="text" value={addFormData.manager_name} onChange={(e) => handleAddChange('manager_name', e.target.value)}
//                       onKeyDown={blockNonAlpha} className={inputCls(addErrors.manager_name)} placeholder="Enter manager's full name" disabled={isSubmitting} />
//                     <FieldError msg={addErrors.manager_name} />
//                     <p className="mt-1 text-xs text-gray-500">Letters and spaces only</p>
//                   </div>
//                   <div>
//                     <label className="block mb-2 text-sm font-medium text-blue-300">Email <span className="text-red-400">*</span></label>
//                     <input type="email" value={addFormData.manager_email} onChange={(e) => handleAddChange('manager_email', e.target.value)}
//                       className={inputCls(addErrors.manager_email)} placeholder="name@domain.com" disabled={isSubmitting} />
//                     <FieldError msg={addErrors.manager_email} />
//                   </div>
//                   <div>
//                     <label className="block mb-2 text-sm font-medium text-blue-300">Phone No. <span className="text-red-400">*</span></label>
//                     <input type="text" value={addFormData.phone_number} onChange={(e) => handleAddChange('phone_number', e.target.value)}
//                       className={inputCls(addErrors.phone_number)} placeholder="1234567891" disabled={isSubmitting} />
//                     <FieldError msg={addErrors.phone_number} />
//                   </div>
//                   <div>
//                     <label className="block mb-2 text-sm font-medium text-blue-300">Password <span className="text-red-400">*</span></label>
//                     <input type="password" value={addFormData.manager_password} onChange={(e) => handleAddChange('manager_password', e.target.value)}
//                       className={inputCls(addErrors.manager_password)} placeholder="Min 6 alphanumeric characters" disabled={isSubmitting} />
//                     <FieldError msg={addErrors.manager_password} />
//                     <p className="mt-1 text-xs text-gray-500">Letters, numbers and special characters allowed</p>
//                   </div>
//                   <div>
//                     <label className="block mb-2 text-sm font-medium text-blue-300">Department <span className="text-red-400">*</span></label>
//                     <input type="text" value={addFormData.department} onChange={(e) => handleAddChange('department', e.target.value)}
//                       onKeyDown={blockNonAlpha} className={inputCls(addErrors.department)} placeholder="Enter department name" disabled={isSubmitting} />
//                     <FieldError msg={addErrors.department} />
//                     <p className="mt-1 text-xs text-gray-500">Letters and spaces only</p>
//                   </div>
//                   <div>
//                     <label className="block mb-2 text-sm font-medium text-blue-300">Role</label>
//                     <select value={addFormData.role} onChange={(e) => handleAddChange('role', e.target.value)} className={inputCls(false)} disabled={isSubmitting}>
//                       <option value="Manager">Manager</option>
//                     </select>
//                   </div>
//                   <div className="sm:col-span-2">
//                     <label className="block mb-2 text-sm font-medium text-blue-300">Status <span className="text-red-400">*</span></label>
//                     <div className="flex gap-4">
//                       {[{ label: 'Active', val: true }, { label: 'Inactive', val: false }].map(({ label, val }) => (
//                         <label key={label} className="flex items-center gap-2 cursor-pointer">
//                           <input type="radio" checked={addFormData.status === val} onChange={() => handleAddChange('status', val)}
//                             className={`w-4 h-4 ${val ? 'text-green-600 focus:ring-green-500' : 'text-red-600 focus:ring-red-500'}`} disabled={isSubmitting} />
//                           <span className="text-sm text-white">{label}</span>
//                         </label>
//                       ))}
//                     </div>
//                     <p className="mt-1 text-xs text-gray-400">Inactive managers won't be able to access the system</p>
//                   </div>
//                 </div>
//                 <div className="flex gap-3 pt-4 pb-2 sm:pb-0">
//                   <button type="button" onClick={() => setIsAddModalOpen(false)} disabled={isSubmitting}
//                     className="flex-1 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-gray-800 border rounded-lg hover:bg-gray-700 border-blue-800/40 disabled:opacity-50">
//                     Cancel
//                   </button>
//                   <button type="submit" disabled={isSubmitting}
//                     className="flex items-center justify-center flex-1 gap-2 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50">
//                     {isSubmitting ? <><SpinnerIcon /> Adding...</> : 'Add Manager'}
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Edit Manager Modal ─────────────────────────────────────────────────── */}
//       {isEditModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm"
//           onClick={() => !isSubmitting && setIsEditModalOpen(false)}>
//           <div className="w-full sm:max-w-md border bg-richblue-950 border-blue-700/50 rounded-t-2xl sm:rounded-2xl max-h-[calc(100dvh-72px)] sm:max-h-[92vh] overflow-y-auto mb-[72px] sm:mb-0"
//             onClick={(e) => e.stopPropagation()}>
//             <div className="flex justify-center pt-3 pb-1 sm:hidden">
//               <div className="w-10 h-1 bg-gray-600 rounded-full" />
//             </div>
//             <div className="p-5 sm:p-8">
//               <h3 className="flex items-center gap-2 mb-5 text-lg font-bold text-white sm:mb-6 sm:text-2xl">
//                 <svg className="w-5 h-5 text-blue-500 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                 </svg>
//                 Edit Manager
//               </h3>
//               <form onSubmit={handleEditSubmit} className="space-y-4" noValidate>
//                 <div>
//                   <label className="block mb-2 text-sm font-medium text-blue-300">Full Name</label>
//                   <input type="text" value={editFormData.manager_name} onChange={(e) => handleEditChange('manager_name', e.target.value)}
//                     onKeyDown={blockNonAlpha} className={inputCls(editErrors.manager_name)} disabled={isSubmitting} />
//                   <FieldError msg={editErrors.manager_name} />
//                   <p className="mt-1 text-xs text-gray-500">Letters and spaces only</p>
//                 </div>
//                 <div>
//                   <label className="block mb-2 text-sm font-medium text-blue-300">Email</label>
//                   <input type="email" value={editFormData.manager_email} onChange={(e) => handleEditChange('manager_email', e.target.value)}
//                     className={inputCls(editErrors.manager_email)} placeholder="name@domain.com" disabled={isSubmitting} />
//                   <FieldError msg={editErrors.manager_email} />
//                 </div>
//                 <div>
//                   <label className="block mb-2 text-sm font-medium text-blue-300">Phone No.</label>
//                   <input type="text" value={editFormData.phone_number} onChange={(e) => handleEditChange('phone_number', e.target.value)}
//                     className={inputCls(editErrors.phone_number)} placeholder="1234567891" disabled={isSubmitting} />
//                   <FieldError msg={editErrors.phone_number} />
//                 </div>
//                 <div>
//                   <label className="block mb-2 text-sm font-medium text-blue-300">Role</label>
//                   <select value={editFormData.role} onChange={(e) => handleEditChange('role', e.target.value)} className={inputCls(false)} disabled={isSubmitting}>
//                     <option value="Manager">Manager</option>
//                   </select>
//                 </div>
//                 <div>
//                   <label className="block mb-2 text-sm font-medium text-blue-300">Department</label>
//                   <input type="text" value={editFormData.department} onChange={(e) => handleEditChange('department', e.target.value)}
//                     onKeyDown={blockNonAlpha} className={inputCls(editErrors.department)} disabled={isSubmitting} />
//                   <FieldError msg={editErrors.department} />
//                   <p className="mt-1 text-xs text-gray-500">Letters and spaces only</p>
//                 </div>
//                 <div>
//                   <label className="block mb-2 text-sm font-medium text-blue-300">Status</label>
//                   <div className="flex gap-4">
//                     {[{ label: 'Active', val: true }, { label: 'Inactive', val: false }].map(({ label, val }) => (
//                       <label key={label} className="flex items-center gap-2 cursor-pointer">
//                         <input type="radio" checked={editFormData.status === val} onChange={() => handleEditChange('status', val)}
//                           className={`w-4 h-4 ${val ? 'text-green-600 focus:ring-green-500' : 'text-red-600 focus:ring-red-500'}`} disabled={isSubmitting} />
//                         <span className="text-sm text-white">{label}</span>
//                       </label>
//                     ))}
//                   </div>
//                   <p className="mt-1 text-xs text-gray-400">
//                     {editFormData.status ? 'Manager has access to the system' : 'Manager cannot access the system'}
//                   </p>
//                 </div>
//                 <div className="flex gap-3 pt-4 pb-2 sm:pb-0">
//                   <button type="submit" disabled={isSubmitting}
//                     className="flex items-center justify-center flex-1 gap-2 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50">
//                     {isSubmitting ? <><SpinnerIcon /> Saving...</> : 'Save Changes'}
//                   </button>
//                   <button type="button" onClick={() => setIsEditModalOpen(false)} disabled={isSubmitting}
//                     className="flex-1 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-gray-800 border rounded-lg hover:bg-gray-700 border-blue-800/40 disabled:opacity-50">
//                     Cancel
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ── Delete Confirmation Modal (single) ──────────────────────────────────────────── */}
//       {isDeleteModalOpen && (
//         <div className="fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 bg-black/50 backdrop-blur-sm"
//           onClick={() => !isSubmitting && setIsDeleteModalOpen(false)}>
//           <div className="w-full sm:max-w-md border bg-richblue-950 border-red-700/50 rounded-2xl sm:rounded-2xl mb-[200px] sm:mb-0"
//             onClick={(e) => e.stopPropagation()}>
//             <div className="flex justify-center pt-3 pb-1 sm:hidden">
//               <div className="w-10 h-1 bg-gray-600 rounded-full" />
//             </div>
//             <div className="p-5 sm:p-8">
//               <h3 className="flex items-center gap-2 mb-4 text-lg font-bold text-white sm:text-2xl">
//                 <svg className="w-5 h-5 text-red-500 sm:w-6 sm:h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                   <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                 </svg>
//                 Confirm Delete
//               </h3>
//               <p className="mb-6 text-sm text-gray-300 sm:text-base">
//                 Are you sure you want to delete{' '}
//                 <span className="font-bold text-white">{selectedManager?.manager_name}</span>?
//                 This action cannot be undone.
//               </p>
//               <div className="flex gap-3 pb-2 sm:pb-0">
//                 <button onClick={() => setIsDeleteModalOpen(false)} disabled={isSubmitting}
//                   className="flex-1 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-gray-800 border rounded-lg hover:bg-gray-700 border-blue-800/40 disabled:opacity-50">
//                   Cancel
//                 </button>
//                 <button onClick={handleDeleteConfirm} disabled={isSubmitting}
//                   className="flex items-center justify-center flex-1 gap-2 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50">
//                   {isSubmitting ? <><SpinnerIcon /> Deleting...</> : 'Delete'}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ManagerManagement;


import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
//import { useNavigate } from "react-router-dom";
import { Update_Manager, Create_Manager, Delete_Manager, Set_Password } from '../../../services/oprations/Manager';
import StandardSpinner from '../../../utils/Spinner';
import { useToast } from '../../Toast';
import { KeyRound, Eye, EyeOff, ChevronDown, ChevronUp, Key, Edit2, Trash2, Check as CheckIcon, Loader2 } from 'lucide-react';
import { useTheme } from '../../../Context/themeContext';

// ─── Validation Rules ─────────────────────────────────────────────────────────
const ALPHA_ONLY = /^[a-zA-Z\s]+$/;
const ALPHANUM   = /^[a-zA-Z0-9!@#$%^&*]+$/;
const EMAIL_RE   = /^[a-zA-Z0-9._%+]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,}$/;
const MOBILE_RE  = /^[0-9]{10}$/;

const validateAddForm = (data) => {
  const errors = {};
  if (!data.manager_name.trim()) errors.manager_name = 'Name is required';
  else if (!ALPHA_ONLY.test(data.manager_name.trim())) errors.manager_name = 'Name must contain letters only';
  if (!data.manager_email.trim()) errors.manager_email = 'Email is required';
  else if (!EMAIL_RE.test(data.manager_email.trim())) errors.manager_email = 'Enter a valid email (name@domain.com)';
  if (!data.phone_number?.trim()) errors.phone_number = 'Mobile number is required';
  else if (!MOBILE_RE.test(data.phone_number.trim())) errors.phone_number = 'Enter a valid 10 digit mobile number';
  if (!data.manager_password) errors.manager_password = 'Password is required';
  else if (data.manager_password.length < 6) errors.manager_password = 'Password must be at least 6 characters';
  else if (!ALPHANUM.test(data.manager_password)) errors.manager_password = 'Password must be alphanumeric';
  if (!data.department.trim()) errors.department = 'Department is required';
  else if (!ALPHA_ONLY.test(data.department.trim())) errors.department = 'Department must contain letters only';
  return errors;
};

const validateEditForm = (data) => {
  const errors = {};
  if (!data.manager_name.trim()) errors.manager_name = 'Name is required';
  else if (!ALPHA_ONLY.test(data.manager_name.trim())) errors.manager_name = 'Name must contain letters only';
  if (!data.manager_email.trim()) errors.manager_email = 'Email is required';
  else if (!EMAIL_RE.test(data.manager_email.trim())) errors.manager_email = 'Enter a valid email (name@domain.com)';
  if (!data.phone_number?.trim()) errors.phone_number = 'Mobile number is required';
  else if (!MOBILE_RE.test(data.phone_number.trim())) errors.phone_number = 'Enter a valid 10 digit mobile number';
  if (!data.department.trim()) errors.department = 'Department is required';
  else if (!ALPHA_ONLY.test(data.department.trim())) errors.department = 'Department must contain letters only';
  return errors;
};

const FieldError = ({ msg }) => msg ? <p className="mt-1 text-xs text-red-400">{msg}</p> : null;

const SpinnerIcon = () => (
  <svg className="w-4 h-4 text-white animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
  </svg>
);

// Mobile manager card with checkbox
const ManagerCard = ({ manager, onEdit, onDelete, onSetPassword, onStatusChange, getStatusBadge, isSelected, onSelect, theme }) => {
  const [open, setOpen] = useState(false);
  const isDark = theme === 'dark';

  const cardBg = isSelected 
    ? isDark ? 'bg-red-900/15 border-red-700/50' : 'bg-red-50 border-red-300'
    : isDark ? 'bg-richblue-800/20 border-blue-700/80' : 'bg-gray-100/50 border-gray-300';
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  const textSecondary = isDark ? 'text-blue-300/70' : 'text-gray-600';

  return (
    <div className={`p-4 space-y-3 border rounded-xl transition-colors ${cardBg}`}>
      {/* Top row with checkbox */}
      <div className="flex items-start justify-between gap-2">
        <div className="flex items-center min-w-0 gap-3">
          <input
            type="checkbox"
            checked={isSelected}
            onChange={(e) => onSelect(e, manager._id)}
            onClick={(e) => e.stopPropagation()}
            className={`flex-shrink-0 w-4 h-4 rounded cursor-pointer ${isDark ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`}
          />
          <div className={`flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full w-9 h-9 bg-gradient-to-br from-blue-600 to-blue-800 ${isDark ? 'border-blue-400/30' : 'border-blue-400'}`}>
            {manager.manager_name?.charAt(0) || 'M'}
          </div>
          <div className="min-w-0">
            <p className={`text-sm font-semibold ${textPrimary} truncate`}>{manager.manager_name}</p>
            <p className={`text-xs truncate ${textSecondary}`}>{manager.manager_email}</p>
          </div>
        </div>
        <span className={`px-2 py-0.5 rounded-full text-xs font-semibold capitalize flex-shrink-0 ${getStatusBadge(manager.status)}`}>
          {manager.status ? 'active' : 'inactive'}
        </span>
      </div>

      {/* Expand toggle */}
      <button
        onClick={() => setOpen(o => !o)}
        className="flex items-center gap-1 text-xs text-blue-400 hover:text-blue-300"
      >
        {open ? <ChevronUp className="w-3 h-3" /> : <ChevronDown className="w-3 h-3" />}
        {open ? 'Less info' : 'More info'}
      </button>

      {open && (
        <div className="grid grid-cols-2 gap-2 text-xs">
          <div>
            <p className="text-blue-400">Phone</p>
            <p className={textPrimary}>{manager.phone_number}</p>
          </div>
          <div>
            <p className="text-blue-400">Role</p>
            <p className={textPrimary}>{manager.role}</p>
          </div>
          <div>
            <p className="text-blue-400">Department</p>
            <p className={textPrimary}>{manager.department || 'Unknown'}</p>
          </div>
        </div>
      )}

      {/* Actions */}
      <div className={`flex items-center gap-2 pt-1 border-t ${isDark ? 'border-blue-800/40' : 'border-gray-300'}`}>
        <button onClick={() => onEdit(manager)}
          className={`p-1.5 border rounded-lg ${isDark ? 'text-blue-300 bg-blue-600/20 hover:bg-blue-600/30 border-blue-700/50' : 'text-blue-700 bg-blue-100 hover:bg-blue-200 border-blue-300'}`}>
          <Edit2 className="w-3.5 h-3.5" />
        </button>
        <button onClick={() => onSetPassword(manager)}
          className={`p-1.5 border rounded-lg ${isDark ? 'text-yellow-300 bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50' : 'text-yellow-700 bg-yellow-100 hover:bg-yellow-200 border-yellow-300'}`}>
          <Key className="w-3.5 h-3.5" /> 
        </button>
        <button onClick={() => onDelete(manager)}
          className={`p-1.5 border rounded-lg ${isDark ? 'text-red-300 bg-red-600/20 hover:bg-red-600/30 border-red-700/50' : 'text-red-700 bg-red-100 hover:bg-red-200 border-red-300'}`}>
          <Trash2 className="w-3.5 h-3.5" />
        </button>
        <button onClick={() => onStatusChange(manager._id, !manager.status)}
          className={`flex-1 flex items-center justify-center px-2 py-1.5 text-xs font-medium border rounded-lg transition-colors ${
            manager.status
              ? isDark ? 'text-yellow-300 bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50' : 'text-yellow-700 bg-yellow-100 hover:bg-yellow-200 border-yellow-300'
              : isDark ? 'text-green-300 bg-green-600/20 hover:bg-green-600/30 border-green-700/50' : 'text-green-700 bg-green-100 hover:bg-green-200 border-green-600'
          }`}>
          {manager.status ? 'Deactivate' : 'Activate'}
        </button>
      </div>
    </div>
  );
};

// ─── Main Component ───────────────────────────────────────────────────────────
const ManagerManagement = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';
  const toast = useToast();
  const { managers } = useSelector((state) => state.manager);
  const dispatch = useDispatch();
  //const navigate = useNavigate();
  const managersData = typeof managers === 'string' ? JSON.parse(managers) : managers;

  const [selectedManager, setSelectedManager] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ── Multi-select / bulk delete ──────────────────────────────────────────
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [isBulkDeleteOpen, setIsBulkDeleteOpen] = useState(false);
  const [isBulkDeleting, setIsBulkDeleting] = useState(false);
  const [bulkProgress, setBulkProgress] = useState({ current: 0, total: 0 });

  const [isSetPasswordModalOpen, setIsSetPasswordModalOpen] = useState(false);
  const [managerForPassword, setManagerForPassword] = useState(null);
  const [newPassword, setNewPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSettingPassword, setIsSettingPassword] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterDepartment, setFilterDepartment] = useState('all');
  const [filtersOpen, setFiltersOpen] = useState(false);

  const [addErrors, setAddErrors] = useState({});
  const [editErrors, setEditErrors] = useState({});

  const [editFormData, setEditFormData] = useState({
    _id: '', manager_name: '', manager_email: '', phone_number: '', role: '', department: '', status: true
  });
  const [addFormData, setAddFormData] = useState({
    manager_name: '', manager_email: '', phone_number: '', manager_password: '', department: '', role: 'Manager', status: true
  });

  // Theme-aware classes
  const bgPrimary = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  //const bgCard = isDark ? 'bg-richblue-800/20' : 'bg-gray-100/50';
  const bgInput = isDark ? 'bg-black' : 'bg-white';
  const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
  const bgTable = isDark ? 'bg-richblue-800/20' : 'bg-white';
  const bgTableHeader = isDark ? 'bg-richblue-950' : 'bg-gray-50';
  const bgHover = isDark ? 'hover:bg-blue-950/30' : 'hover:bg-gray-50';
  
  const borderColor = isDark ? 'border-blue-700/80' : 'border-gray-300';
  //const borderLight = isDark ? 'border-blue-800/60' : 'border-gray-200';
  //const borderLighter = isDark ? 'border-blue-700/80' : 'border-gray-300';
  const borderInput = isDark ? 'border-blue-800/60' : 'border-gray-300';
  
  const textPrimary = isDark ? 'text-white' : 'text-gray-900';
  //const textSecondary = isDark ? 'text-blue-300' : 'text-gray-600';
  //const textMuted = isDark ? 'text-blue-400/80' : 'text-gray-500';
  //const textLight = isDark ? 'text-blue-300/80' : 'text-gray-700';
  const textPlaceholder = isDark ? 'placeholder-blue-400/40' : 'placeholder-gray-400';
  
  const shadowColor = isDark ? 'shadow-blue-800/60' : 'shadow-gray-300';
  //const shadowLight = isDark ? 'shadow-blue-900/20' : 'shadow-gray-200';

  useEffect(() => { setTimeout(() => setLoading(false), 800); }, []);

  // ── Helper: Sort managers alphabetically by name ──────────────────────────
  const sortManagersAlphabetically = (managerArray) => {
    if (!managerArray || !Array.isArray(managerArray)) return [];
    return [...managerArray].sort((a, b) => {
      const nameA = (a.manager_name || '').toLowerCase();
      const nameB = (b.manager_name || '').toLowerCase();
      return nameA.localeCompare(nameB);
    });
  };

  // Apply sorting to managers data
  const sortedManagers = sortManagersAlphabetically(managersData);

  const departments = ['all', ...new Set(sortedManagers?.map(m => m.department) || [])];

  // Apply filters to SORTED managers
  const filteredManagers = sortedManagers?.filter(manager => {
    const matchesSearch =
      manager.manager_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      manager.manager_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      manager.department?.toLowerCase().includes(searchTerm.toLowerCase());
    let matchesStatus = true;
    if (filterStatus === 'ACTIVE') matchesStatus = manager.status === true;
    else if (filterStatus === 'DEACTIVE') matchesStatus = manager.status === false;
    const matchesDepartment = filterDepartment === 'all' || manager.department === filterDepartment;
    return matchesSearch && matchesStatus && matchesDepartment;
  }) || [];

  // ── Selection helpers ───────────────────────────────────────────────────
  const allFilteredSelected = filteredManagers.length > 0 && filteredManagers.every(m => selectedIds.has(m._id));
  const someSelected = selectedIds.size > 0;

  const toggleSelectAll = () => {
    if (allFilteredSelected) {
      setSelectedIds(prev => {
        const next = new Set(prev);
        filteredManagers.forEach(m => next.delete(m._id));
        return next;
      });
    } else {
      setSelectedIds(prev => {
        const next = new Set(prev);
        filteredManagers.forEach(m => next.add(m._id));
        return next;
      });
    }
  };

  const toggleSelectManager = (e, managerId) => {
    e.stopPropagation();
    setSelectedIds(prev => {
      const next = new Set(prev);
      next.has(managerId) ? next.delete(managerId) : next.add(managerId);
      return next;
    });
  };

  const clearSelection = () => setSelectedIds(new Set());

  // ── Bulk delete ─────────────────────────────────────────────────────────
  const handleBulkDeleteConfirm = async () => {
    const ids = [...selectedIds];
    setIsBulkDeleting(true);
    setBulkProgress({ current: 0, total: ids.length });

    let successCount = 0;
    let errorCount = 0;

    for (let i = 0; i < ids.length; i++) {
      setBulkProgress({ current: i + 1, total: ids.length });
      try {
        const res = await dispatch(Delete_Manager(ids[i]));
        if (res?.data?.success) successCount++;
        else errorCount++;
      } catch {
        errorCount++;
      }
    }

    if (successCount > 0) toast.success(`Deleted ${successCount} manager${successCount > 1 ? 's' : ''}${errorCount > 0 ? `, ${errorCount} failed` : ''} successfully`);
    if (errorCount > 0 && successCount === 0) toast.error(`Failed to delete ${errorCount} manager${errorCount > 1 ? 's' : ''}`);

    setIsBulkDeleting(false);
    setIsBulkDeleteOpen(false);
    setBulkProgress({ current: 0, total: 0 });
    clearSelection();
  };

  const handleAddChange = (field, value) => {
    setAddFormData(prev => ({ ...prev, [field]: value }));
    if (addErrors[field]) setAddErrors(prev => ({ ...prev, [field]: '' }));
  };
  const handleEditChange = (field, value) => {
    setEditFormData(prev => ({ ...prev, [field]: value }));
    if (editErrors[field]) setEditErrors(prev => ({ ...prev, [field]: '' }));
  };
  const blockNonAlpha = (e) => {
    const allowed = /^[a-zA-Z\s]$/;
    if (!allowed.test(e.key) && !['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End'].includes(e.key)) e.preventDefault();
  };
  const handleStatusChange = (managerId, newStatus) => dispatch(Update_Manager({ status: newStatus }, managerId));

  const handleEditClick = (manager) => {
    setSelectedManager(manager);
    setEditErrors({});
    setEditFormData({
      _id: manager._id, manager_name: manager.manager_name, manager_email: manager.manager_email,
      phone_number: manager.phone_number, role: manager.role, department: manager.department || '', status: manager.status
    });
    setIsEditModalOpen(true);
  };
  const handleAddClick = () => {
    setAddErrors({});
    setAddFormData({ manager_name: '', manager_email: '', phone_number: '', manager_password: '', department: '', role: 'Manager', status: true });
    setIsAddModalOpen(true);
  };
  const handleSetPasswordClick = (manager) => {
    setManagerForPassword(manager); setNewPassword(''); setShowPassword(false); setIsSetPasswordModalOpen(true);
  };
  const handleSetPasswordSubmit = async (e) => {
    e.preventDefault();
    if (!managerForPassword || !newPassword.trim()) return;
    setIsSettingPassword(true);
    try {
      const res = await dispatch(Set_Password(managerForPassword._id, newPassword));
      if (res.data.success) toast.success(res.data.message || 'Password updated successfully');
      else toast.error(res.data.message || 'Error updating password');
    } finally {
      setIsSettingPassword(false); setIsSetPasswordModalOpen(false);
      setManagerForPassword(null); setNewPassword('');
    }
  };
  const closeSetPasswordModal = () => {
    if (isSettingPassword) return;
    setIsSetPasswordModalOpen(false); setManagerForPassword(null); setNewPassword(''); setShowPassword(false);
  };
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const errs = validateEditForm(editFormData);
    if (Object.keys(errs).length > 0) { setEditErrors(errs); return; }
    setIsSubmitting(true);
    try {
      const res = await dispatch(Update_Manager(editFormData, editFormData._id));
      setIsEditModalOpen(false); setSelectedManager(null);
      if (res?.data?.success) toast.success(res.data.message || 'Manager updated successfully');
      else toast.error(res?.data?.message || 'Error updating manager');
    } catch { toast.error('Unexpected error occurred'); }
    finally { setIsSubmitting(false); }
  };
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    const errs = validateAddForm(addFormData);
    if (Object.keys(errs).length > 0) { setAddErrors(errs); return; }
    setIsSubmitting(true);
    try {
      const res = await dispatch(Create_Manager(addFormData));
      setIsAddModalOpen(false);
      if (res?.data?.success) toast.success(res.data.message || 'Manager created successfully');
      else toast.error(res?.data?.message || 'Error creating manager');
      setAddFormData({ manager_name: '', manager_email: '', phone_number: '', manager_password: '', department: '', role: 'Manager', status: true });
    } catch { toast.error('Unexpected error occurred'); }
    finally { setIsSubmitting(false); }
  };
  const handleDeleteClick = (manager) => { setSelectedManager(manager); setIsDeleteModalOpen(true); };
  const handleDeleteConfirm = async () => {
    setIsSubmitting(true);
    try {
      const res = await dispatch(Delete_Manager(selectedManager._id));
      setIsDeleteModalOpen(false); setSelectedManager(null);
      if (res?.data?.success) toast.success(res.data.message || 'Manager deleted successfully');
      else toast.error(res?.data?.message || 'Error deleting manager');
    } catch { toast.error('Unexpected error occurred'); }
    finally { setIsSubmitting(false); }
  };

  const getStatusBadge = (status) => {
    if (status) {
      return isDark 
        ? 'bg-green-900/50 text-green-300 border border-green-700/50'
        : 'bg-green-100 text-green-700 border border-green-600';
    }
    return isDark
      ? 'bg-red-900/50 text-red-300 border border-red-700/50'
      : 'bg-red-100 text-red-700 border border-red-300';
  };

  const inputCls = (hasError) =>
    `w-full p-3 ${textPrimary} ${bgInput} border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 text-sm ${
      hasError ? 'border-red-500' : borderInput
    } ${textPlaceholder}`;

  if (loading) return <StandardSpinner />;

  return (
    <div className={`flex flex-col h-full font-sans ${textPrimary} ${bgPrimary} transition-colors duration-300`}>
      <div className={`flex-none p-3 sm:p-4 ${bgPrimary}`}>

        {/* Header */}
        <div className="flex flex-wrap items-center justify-between gap-3 mb-3 sm:mb-5">
          <div>
            <h1 className={`text-xl font-bold text-transparent sm:text-3xl ${isDark ? 'bg-gradient-to-r from-blue-200 to-blue-400' : 'bg-gradient-to-r from-blue-600 to-blue-800'} bg-clip-text`}>
              Manager Management
            </h1>
            <p className={`mt-1 text-xs sm:text-sm ${isDark ? 'text-blue-400/80' : 'text-gray-500'}`}>Manage all managers and their permissions</p>
          </div>
          <button onClick={handleAddClick}
            className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-white transition-all duration-200 border border-blue-400 rounded-lg sm:px-4 bg-gradient-to-br from-blue-500 to-blue-700">
            <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z" clipRule="evenodd" />
            </svg>
            <span className="whitespace-nowrap">Add Manager</span>
          </button>
        </div>

        {/* Stats — using sortedManagers for accurate counts */}
        <div className="grid grid-cols-2 gap-2 mb-3 sm:gap-3 sm:mb-5 md:grid-cols-4">
          {[
            { label: 'Total Managers',    value: sortedManagers.length,                              color: isDark ? 'text-white' : 'text-gray-900' },
            { label: 'Active',            value: sortedManagers.filter(m => m.status).length,        color: 'text-green-600' },
            { label: 'Inactive',          value: sortedManagers.filter(m => !m.status).length,       color: 'text-red-400' },
            { label: 'Departments',       value: new Set(sortedManagers.map(m => m.department)).size, color: isDark ? 'text-blue-300' : 'text-blue-600' },
          ].map(({ label, value, color }) => (
            <div key={label} className={`p-3 border sm:p-4 ${isDark ? 'bg-richblue-600/20 border-blue-700/80' : 'bg-gray-100 border-gray-300'} rounded-xl transition-colors duration-300`}>
              <p className={`text-xs ${isDark ? 'text-blue-300' : 'text-gray-600'} truncate`}>{label}</p>
              <p className={`mt-1 text-xl sm:text-2xl font-bold ${color}`}>{value}</p>
            </div>
          ))}
        </div>

        {/* Search + Filters */}
        <div className="space-y-2">
          {/* Search bar — always visible */}
          <div className="flex gap-2">
            <div className="relative flex-1">
              <input
                type="text"
                placeholder="Search by name, email or department..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className={`w-full py-2 pl-10 pr-4 text-sm ${textPrimary} ${isDark ? 'bg-richblue-600/20 border-blue-700/80 placeholder-blue-400/40' : 'bg-gray-100 border-gray-300 placeholder-gray-400'} border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
              />
              <svg className={`absolute left-3 top-2.5 h-4 w-4 ${isDark ? 'text-blue-400/60' : 'text-gray-400'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            {/* Filter toggle on mobile */}
            <button
              onClick={() => setFiltersOpen(o => !o)}
              className={`flex items-center gap-1 px-3 py-2 text-xs border rounded-lg ${isDark ? 'text-blue-300 bg-richblue-600/20 border-blue-700/80' : 'text-gray-600 bg-gray-100 border-gray-300'}`}
            >
              {filtersOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
              Filters
            </button>
          </div>

          {/* Filter dropdowns — always visible on md+, toggleable on mobile */}
          <div className={`${filtersOpen ? 'flex' : 'hidden'} md:flex flex-col sm:flex-row gap-2`}>
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className={`flex-1 px-4 py-2 text-sm ${textPrimary} border rounded-lg ${isDark ? 'bg-richblue-600/20 border-blue-700/80' : 'bg-gray-100 border-gray-300'} focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
            >
              <option value="all">All Status</option>
              <option value="ACTIVE">Active</option>
              <option value="DEACTIVE">Deactive</option>
            </select>
            <select
              value={filterDepartment}
              onChange={(e) => setFilterDepartment(e.target.value)}
              className={`flex-1 px-4 py-2 text-sm ${textPrimary} border rounded-lg ${isDark ? 'bg-richblue-600/20 border-blue-700/80' : 'bg-gray-100 border-gray-300'} focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
            >
              {departments.map(dept => (
                <option key={dept} value={dept}>{dept === 'all' ? 'All Departments' : dept}</option>
              ))}
            </select>
          </div>
        </div>
      </div>

      {/* ── BULK ACTION BAR (appears when items are selected) ─────────── */}
      {someSelected && (
        <div className={`flex items-center justify-between gap-3 px-3 py-2.5 mx-3 sm:mx-4 mb-2 rounded-xl border ${isDark ? 'border-red-700/50 bg-red-900/20' : 'border-red-300 bg-red-50'}`}>
          <div className={`flex items-center gap-2 text-sm ${isDark ? 'text-red-300' : 'text-red-700'}`}>
            <CheckIcon className="w-4 h-4" />
            <span className="font-medium">{selectedIds.size} manager{selectedIds.size > 1 ? 's' : ''} selected</span>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={clearSelection}
              className={`px-3 py-1.5 text-xs border rounded-lg ${isDark ? 'text-blue-100 border-blue-400/80 hover:bg-blue-800/30' : 'text-gray-700 border-gray-400 hover:bg-gray-200'} transition-colors`}
            >
              Clear
            </button>
            <button
              onClick={() => setIsBulkDeleteOpen(true)}
              className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors"
            >
              <Trash2 className="w-3.5 h-3.5" />
              Delete Selected
            </button>
          </div>
        </div>
      )}

      {/* Content */}
      <div className="flex-1 px-3 pb-4 sm:px-4">

        {/* Mobile: card list (hidden on md+) */}
        <div className="space-y-3 md:hidden">
          {/* Mobile select-all bar */}
          {filteredManagers.length > 0 && (
            <div className="flex items-center justify-between px-1">
              <label className={`flex items-center gap-2 text-xs cursor-pointer select-none ${isDark ? 'text-blue-300' : 'text-gray-700'}`} onClick={toggleSelectAll}>
                <input
                  type="checkbox"
                  checked={allFilteredSelected}
                  onChange={toggleSelectAll}
                  className={`w-4 h-4 rounded ${isDark ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`}
                />
                Select all ({filteredManagers.length})
              </label>
            </div>
          )}
          
          {filteredManagers.length > 0 ? (
            filteredManagers.map(manager => (
              <ManagerCard
                key={manager._id}
                manager={manager}
                onEdit={handleEditClick}
                onDelete={handleDeleteClick}
                onSetPassword={handleSetPasswordClick}
                onStatusChange={handleStatusChange}
                getStatusBadge={getStatusBadge}
                isSelected={selectedIds.has(manager._id)}
                onSelect={toggleSelectManager}
                theme={theme}
              />
            ))
          ) : (
            <p className={`py-8 text-sm text-center ${isDark ? 'text-blue-400/60' : 'text-gray-500'}`}>No managers found matching your criteria</p>
          )}
        </div>

        {/* Desktop: table (hidden on mobile) */}
        <div className={`hidden border shadow-xl md:block ${bgTable} ${borderColor} rounded-xl ${shadowColor} transition-colors duration-300`}>
          <div className="overflow-y-auto overflow-x-auto max-h-[500px] rounded-xl">
            <table className="w-full text-left border-collapse">
              <thead className={`sticky top-0 z-10 ${bgTableHeader} transition-colors duration-300`}>
                <tr className={`border-b ${isDark ? 'border-blue-800/60' : 'border-gray-300'}`}>
                  {/* Select-all checkbox column */}
                  <th className="w-10 p-3">
                    <input
                      type="checkbox"
                      checked={allFilteredSelected}
                      onChange={toggleSelectAll}
                      className={`w-4 h-4 rounded cursor-pointer ${isDark ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`}
                    />
                  </th>
                  {['Manager','Email','Phone No.','Role','Department','Status','Actions'].map((h, i) => (
                    <th key={h} className={`p-4 font-semibold text-sm ${isDark ? 'text-blue-300' : 'text-gray-700'} whitespace-nowrap border-b ${isDark ? 'border-blue-800/60' : 'border-gray-300'} ${bgTableHeader}`}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className={`divide-y ${isDark ? 'divide-blue-900/30' : 'divide-gray-200'}`}>
                {filteredManagers.length > 0 ? (
                  filteredManagers.map((manager) => {
                    const isSelected = selectedIds.has(manager._id);
                    return (
                      <tr key={manager._id} className={`transition-colors ${isDark ? bgHover : 'hover:bg-gray-50'} ${isSelected ? (isDark ? 'bg-red-900/10' : 'bg-red-50') : ''}`}>
                        <td className={`p-3 border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={(e) => toggleSelectManager(e, manager._id)}
                            onClick={(e) => e.stopPropagation()}
                            className={`w-4 h-4 rounded cursor-pointer ${isDark ? 'text-red-500 border-blue-700 bg-richblue-900 focus:ring-red-600/50' : 'text-red-500 border-gray-300 bg-white focus:ring-red-500'}`}
                          />
                        </td>
                        <td className={`p-4 border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>
                          <div className="flex items-center gap-3 whitespace-nowrap">
                            <div className={`flex items-center justify-center flex-shrink-0 font-bold text-white border rounded-full w-9 h-9 bg-gradient-to-br from-blue-500 to-blue-700 ${isDark ? 'border-blue-400/30' : 'border-blue-400'}`}>
                              {manager.manager_name?.charAt(0) || 'M'}
                            </div>
                            <span className={`text-sm font-medium ${textPrimary}`}>{manager.manager_name}</span>
                          </div>
                        </td>
                        <td className={`p-4 text-sm ${isDark ? 'text-blue-300/80' : 'text-gray-600'} whitespace-nowrap border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>{manager.manager_email}</td>
                        <td className={`p-4 text-sm ${isDark ? 'text-blue-300/80' : 'text-gray-600'} whitespace-nowrap border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>{manager.phone_number}</td>
                        <td className={`p-4 text-sm ${textPrimary} whitespace-nowrap border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>{manager.role}</td>
                        <td className={`p-4 text-sm ${isDark ? 'text-gray-400' : 'text-gray-500'} whitespace-nowrap border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>{manager.department || 'Unknown'}</td>
                        <td className={`p-4 border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>
                          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold capitalize whitespace-nowrap ${getStatusBadge(manager.status)}`}>
                            {manager.status ? 'active' : 'inactive'}
                          </span>
                        </td>
                        <td className={`p-2 border-b ${isDark ? 'border-blue-900/30' : 'border-gray-200'}`}>
                          <div className="flex items-center gap-1.5">
                            <button onClick={() => handleEditClick(manager)}
                              className={`p-2 transition-colors border rounded-lg ${isDark ? 'text-blue-300 bg-blue-600/20 hover:bg-blue-600/30 border-blue-700/50' : 'text-blue-700 bg-blue-100/20 hover:bg-blue-200/30 border-blue-100'}`} title="Edit">
                              <Edit2 className={`w-3.5 h-3.5 ${isDark ? 'text-blue-300' : 'text-blue-700'}`} />
                            </button>
                            <button onClick={() => handleSetPasswordClick(manager)}
                              className={`p-2 transition-colors border rounded-lg ${isDark ? 'bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50' : 'bg-yellow-100/20 hover:bg-yellow-200/30 border-yellow-100'}`} title="Set Password">
                              <Key className={`w-4 h-4 ${isDark ? 'text-yellow-400' : 'text-yellow-700'}`} />
                            </button>
                            <button onClick={() => handleDeleteClick(manager)}
                              className={`p-2 transition-colors border rounded-lg ${isDark ? 'bg-red-600/20 hover:bg-red-600/30 border-red-700/50' : 'bg-red-100 hover:bg-red-200 border-red-300'}`} title="Delete">
                              <Trash2 className={`w-3.5 h-3.5 ${isDark ? 'text-red-300' : 'text-red-700'}`} />
                            </button>
                            {manager.status ? (
                              <button onClick={() => handleStatusChange(manager._id, false)}
                                className={`px-2 py-1 text-xs font-medium transition-colors border rounded-lg whitespace-nowrap ${isDark ? 'text-yellow-300 bg-yellow-600/20 hover:bg-yellow-600/30 border-yellow-700/50' : 'text-yellow-700 bg-yellow-100/20 hover:bg-yellow-200/30 border-yellow-200'}`}>
                                Deactivate
                              </button>
                            ) : (
                              <button onClick={() => handleStatusChange(manager._id, true)}
                                className={`px-2 py-1 text-xs font-medium transition-colors border rounded-lg whitespace-nowrap ${isDark ? 'text-green-300 bg-green-600/20 hover:bg-green-600/30 border-green-700/50' : 'text-green-700 bg-green-100 hover:bg-green-200 border-green-600'}`}>
                                Activate
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="8" className={`p-8 text-center ${isDark ? 'text-blue-400/60' : 'text-gray-500'}`}>No managers found matching your criteria</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* ── BULK DELETE CONFIRMATION MODAL ───────────────────────────── */}
      {isBulkDeleteOpen && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 ${isDark ? 'bg-black/60' : 'bg-black/40'} backdrop-blur-sm`} onClick={() => !isBulkDeleting && setIsBulkDeleteOpen(false)}>
          <div className={`w-full border sm:max-w-md ${bgModal} ${isDark ? 'border-red-700/50' : 'border-red-300'} rounded-t-2xl sm:rounded-2xl transition-colors duration-300`} onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-center pt-3 pb-1 sm:hidden">
              <div className={`w-10 h-1 ${isDark ? 'bg-gray-600' : 'bg-gray-300'} rounded-full`} />
            </div>
            <div className="p-5 space-y-4 sm:p-6">
              <div className="flex items-start gap-3">
                <div className={`flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full ${isDark ? 'bg-red-600/20' : 'bg-red-100'}`}>
                  <Trash2 className={`w-5 h-5 ${isDark ? 'text-red-400' : 'text-red-600'}`} />
                </div>
                <div>
                  <h3 className={`text-base font-bold ${textPrimary}`}>Delete {selectedIds.size} Manager{selectedIds.size > 1 ? 's' : ''}?</h3>
                  <p className={`mt-1 text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
                    This will permanently delete {selectedIds.size === 1 ? 'the selected manager' : `all ${selectedIds.size} selected managers`}. This action cannot be undone.
                  </p>
                </div>
              </div>

              {/* Selected manager names preview */}
              <div className={`p-3 space-y-1 overflow-y-auto border rounded-lg max-h-32 ${isDark ? 'border-red-800/30 bg-red-900/10' : 'border-red-200 bg-red-50'}`}>
                {[...selectedIds].map(id => {
                  const m = managersData?.find(m => m._id === id);
                  return m ? (
                    <div key={id} className="flex items-center gap-2 text-sm">
                      <div className="flex-shrink-0 w-5 h-5 rounded-full bg-gradient-to-br from-blue-600 to-blue-800 flex items-center justify-center text-[10px] font-bold text-white">
                        {m.manager_name?.charAt(0)}
                      </div>
                      <span className={textPrimary}>{m.manager_name}</span>
                      <span className={`flex-shrink-0 ml-auto text-xs ${isDark ? 'text-blue-400/50' : 'text-gray-500'}`}>{m.manager_email}</span>
                    </div>
                  ) : null;
                })}
              </div>

              {/* Progress bar (shown while deleting) */}
              {isBulkDeleting && (
                <div className="space-y-2">
                  <div className={`flex justify-between text-xs ${isDark ? 'text-blue-300' : 'text-blue-700'}`}>
                    <span>Deleting managers...</span>
                    <span>{bulkProgress.current} / {bulkProgress.total}</span>
                  </div>
                  <div className={`w-full h-2 rounded-full ${isDark ? 'bg-richblue-900' : 'bg-gray-200'}`}>
                    <div
                      className="h-2 transition-all duration-300 bg-red-600 rounded-full"
                      style={{ width: `${bulkProgress.total > 0 ? (bulkProgress.current / bulkProgress.total) * 100 : 0}%` }}
                    />
                  </div>
                </div>
              )}

              <div className="flex gap-3 pb-2 sm:pb-0">
                <button
                  type="button"
                  onClick={() => setIsBulkDeleteOpen(false)}
                  disabled={isBulkDeleting}
                  className={`flex-1 py-2.5 text-sm font-medium border rounded-lg ${isDark ? 'text-blue-300 border-blue-800/60 hover:bg-blue-800/20' : 'text-gray-700 border-gray-300 hover:bg-gray-100'} transition-colors disabled:opacity-50`}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleBulkDeleteConfirm}
                  disabled={isBulkDeleting}
                  className="flex-1 flex items-center justify-center gap-2 py-2.5 text-sm font-semibold text-white bg-red-600 rounded-lg hover:bg-red-500 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isBulkDeleting
                    ? <><Loader2 className="w-4 h-4 animate-spin" /> Deleting...</>
                    : <><Trash2 className="w-4 h-4" /> Delete {selectedIds.size} Manager{selectedIds.size > 1 ? 's' : ''}</>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Set Password Modal ─────────────────────────────────────────────────── */}
      {isSetPasswordModalOpen && managerForPassword && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`}
          onClick={closeSetPasswordModal}>
          <div className={`w-full sm:max-w-sm border shadow-2xl ${bgModal} ${isDark ? 'border-yellow-700/40 shadow-yellow-900/20' : 'border-yellow-300 shadow-yellow-200'} rounded-2xl sm:rounded-2xl mb-[172px] sm:mb-0 transition-colors duration-300`}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-center pt-3 pb-1 sm:hidden">
              <div className={`w-10 h-1 ${isDark ? 'bg-gray-600' : 'bg-gray-300'} rounded-full`} />
            </div>
            <div className={`flex items-center justify-between p-4 border-b sm:p-5 ${isDark ? 'border-blue-800/40' : 'border-gray-200'}`}>
              <h3 className={`flex items-center gap-2 text-base font-bold ${textPrimary} sm:text-lg`}>
                <KeyRound className={`w-4 h-4 ${isDark ? 'text-yellow-400' : 'text-yellow-600'} sm:w-5 sm:h-5`} />
                Set Password
              </h3>
              <button onClick={closeSetPasswordModal} disabled={isSettingPassword}
                className={`p-1.5 rounded-lg ${isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100'} transition-colors disabled:opacity-50`}>
                <svg className={`w-5 h-5 ${isDark ? 'text-blue-400' : 'text-gray-600'}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <div className="p-4 space-y-4 sm:p-5">
              <div className={`flex items-center gap-3 px-4 py-3 border ${isDark ? 'bg-richblue-900 border-blue-800/40' : 'bg-gray-100 border-gray-200'} rounded-xl`}>
                <div className={`flex items-center justify-center flex-shrink-0 text-sm font-bold text-white border rounded-full h-9 w-9 bg-gradient-to-br from-blue-600 to-blue-800 ${isDark ? 'border-blue-400/30' : 'border-blue-400'}`}>
                  {managerForPassword.manager_name?.charAt(0) || 'M'}
                </div>
                <div className="min-w-0">
                  <p className={`text-sm font-medium ${textPrimary} truncate`}>{managerForPassword.manager_name}</p>
                  <p className={`text-xs truncate ${isDark ? 'text-blue-400/60' : 'text-gray-500'}`}>{managerForPassword.manager_email}</p>
                </div>
              </div>
              <div>
                <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>New Password</label>
                <div className="relative">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    placeholder="Enter new password"
                    disabled={isSettingPassword}
                    className={`w-full ${isDark ? 'bg-richblue-900 border-blue-800/60 text-white placeholder-blue-400/40' : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400'} border rounded-lg pl-4 pr-11 py-2.5 focus:outline-none focus:ring-2 focus:ring-yellow-600/60 text-sm disabled:opacity-50 transition-colors duration-300`}
                    autoFocus
                  />
                  <button type="button" onClick={() => setShowPassword(p => !p)}
                    className={`absolute transition-colors -translate-y-1/2 right-3 top-1/2 ${isDark ? 'text-blue-400/60 hover:text-blue-300' : 'text-gray-400 hover:text-gray-600'}`}>
                    {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                  </button>
                </div>
              </div>
              <div className="flex gap-3 pt-1 pb-2 sm:pb-0">
                <button type="button" onClick={closeSetPasswordModal} disabled={isSettingPassword}
                  className={`flex-1 px-4 py-2.5 rounded-lg border ${isDark ? 'border-blue-800/60 text-blue-300 hover:bg-blue-800/20' : 'border-gray-300 text-gray-700 hover:bg-gray-100'} transition-colors text-sm font-medium disabled:opacity-50`}>
                  Cancel
                </button>
                <button type="button" onClick={handleSetPasswordSubmit}
                  disabled={!newPassword.trim() || isSettingPassword}
                  className="flex-1 px-4 py-2.5 rounded-lg bg-yellow-600 hover:bg-yellow-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors text-white text-sm font-semibold flex items-center justify-center gap-2">
                  {isSettingPassword ? <><SpinnerIcon />Updating...</> : <><KeyRound className="w-4 h-4" />Set Password</>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── Add Manager Modal ──────────────────────────────────────────────────── */}
      {isAddModalOpen && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`}
          onClick={() => !isSubmitting && setIsAddModalOpen(false)}>
          <div className={`w-full sm:max-w-2xl border ${bgModal} ${isDark ? 'border-blue-700/50' : 'border-gray-300'} rounded-t-2xl sm:rounded-2xl max-h-[calc(100dvh-72px)] sm:max-h-[92vh] overflow-y-auto mb-[72px] sm:mb-0 transition-colors duration-300`}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-center pt-3 pb-1 sm:hidden">
              <div className={`w-10 h-1 ${isDark ? 'bg-gray-600' : 'bg-gray-300'} rounded-full`} />
            </div>
            <div className="p-5 sm:p-8">
              <h3 className={`flex items-center gap-2 mb-5 text-lg font-bold ${textPrimary} sm:mb-6 sm:text-2xl`}>
                <svg className={`w-5 h-5 ${isDark ? 'text-blue-500' : 'text-blue-600'} sm:w-6 sm:h-6`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                </svg>
                Add New Manager
              </h3>
              <form onSubmit={handleAddSubmit} className="space-y-4" noValidate>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div>
                    <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Full Name <span className="text-red-400">*</span></label>
                    <input type="text" value={addFormData.manager_name} onChange={(e) => handleAddChange('manager_name', e.target.value)}
                      onKeyDown={blockNonAlpha} className={inputCls(addErrors.manager_name)} placeholder="Enter manager's full name" disabled={isSubmitting} />
                    <FieldError msg={addErrors.manager_name} />
                    <p className={`mt-1 text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Letters and spaces only</p>
                  </div>
                  <div>
                    <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Email <span className="text-red-400">*</span></label>
                    <input type="email" value={addFormData.manager_email} onChange={(e) => handleAddChange('manager_email', e.target.value)}
                      className={inputCls(addErrors.manager_email)} placeholder="name@domain.com" disabled={isSubmitting} />
                    <FieldError msg={addErrors.manager_email} />
                  </div>
                  <div>
                    <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Phone No. <span className="text-red-400">*</span></label>
                    <input type="text" value={addFormData.phone_number} onChange={(e) => handleAddChange('phone_number', e.target.value)}
                      className={inputCls(addErrors.phone_number)} placeholder="1234567891" disabled={isSubmitting} />
                    <FieldError msg={addErrors.phone_number} />
                  </div>
                  <div>
                    <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Password <span className="text-red-400">*</span></label>
                    <input type="password" value={addFormData.manager_password} onChange={(e) => handleAddChange('manager_password', e.target.value)}
                      className={inputCls(addErrors.manager_password)} placeholder="Min 6 alphanumeric characters" disabled={isSubmitting} />
                    <FieldError msg={addErrors.manager_password} />
                    <p className={`mt-1 text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Letters, numbers and special characters allowed</p>
                  </div>
                  <div>
                    <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Department <span className="text-red-400">*</span></label>
                    <input type="text" value={addFormData.department} onChange={(e) => handleAddChange('department', e.target.value)}
                      onKeyDown={blockNonAlpha} className={inputCls(addErrors.department)} placeholder="Enter department name" disabled={isSubmitting} />
                    <FieldError msg={addErrors.department} />
                    <p className={`mt-1 text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Letters and spaces only</p>
                  </div>
                  <div>
                    <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Role</label>
                    <select value={addFormData.role} onChange={(e) => handleAddChange('role', e.target.value)} className={inputCls(false)} disabled={isSubmitting}>
                      <option value="Manager">Manager</option>
                    </select>
                  </div>
                  <div className="sm:col-span-2">
                    <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Status <span className="text-red-400">*</span></label>
                    <div className="flex gap-4">
                      {[{ label: 'Active', val: true }, { label: 'Inactive', val: false }].map(({ label, val }) => (
                        <label key={label} className="flex items-center gap-2 cursor-pointer">
                          <input type="radio" checked={addFormData.status === val} onChange={() => handleAddChange('status', val)}
                            className={`w-4 h-4 ${val ? 'text-green-600 focus:ring-green-500' : 'text-red-600 focus:ring-red-500'}`} disabled={isSubmitting} />
                          <span className={`text-sm ${textPrimary}`}>{label}</span>
                        </label>
                      ))}
                    </div>
                    <p className={`mt-1 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>Inactive managers won't be able to access the system</p>
                  </div>
                </div>
                <div className="flex gap-3 pt-4 pb-2 sm:pb-0">
                  <button type="button" onClick={() => setIsAddModalOpen(false)} disabled={isSubmitting}
                    className={`flex-1 py-2.5 sm:py-3 text-sm font-medium transition-colors border rounded-lg ${isDark ? 'text-white bg-gray-800 hover:bg-gray-700 border-blue-800/40' : 'text-gray-700 bg-gray-200 hover:bg-gray-300 border-gray-300'} disabled:opacity-50`}>
                    Cancel
                  </button>
                  <button type="submit" disabled={isSubmitting}
                    className="flex items-center justify-center flex-1 gap-2 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50">
                    {isSubmitting ? <><SpinnerIcon /> Adding...</> : 'Add Manager'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ── Edit Manager Modal ─────────────────────────────────────────────────── */}
      {isEditModalOpen && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`}
          onClick={() => !isSubmitting && setIsEditModalOpen(false)}>
          <div className={`w-full sm:max-w-md border ${bgModal} ${isDark ? 'border-blue-700/50' : 'border-gray-300'} rounded-t-2xl sm:rounded-2xl max-h-[calc(100dvh-72px)] sm:max-h-[92vh] overflow-y-auto mb-[72px] sm:mb-0 transition-colors duration-300`}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-center pt-3 pb-1 sm:hidden">
              <div className={`w-10 h-1 ${isDark ? 'bg-gray-600' : 'bg-gray-300'} rounded-full`} />
            </div>
            <div className="p-5 sm:p-8">
              <h3 className={`flex items-center gap-2 mb-5 text-lg font-bold ${textPrimary} sm:mb-6 sm:text-2xl`}>
                <svg className={`w-5 h-5 ${isDark ? 'text-blue-500' : 'text-blue-600'} sm:w-6 sm:h-6`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                </svg>
                Edit Manager
              </h3>
              <form onSubmit={handleEditSubmit} className="space-y-4" noValidate>
                <div>
                  <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Full Name</label>
                  <input type="text" value={editFormData.manager_name} onChange={(e) => handleEditChange('manager_name', e.target.value)}
                    onKeyDown={blockNonAlpha} className={inputCls(editErrors.manager_name)} disabled={isSubmitting} />
                  <FieldError msg={editErrors.manager_name} />
                  <p className={`mt-1 text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Letters and spaces only</p>
                </div>
                <div>
                  <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Email</label>
                  <input type="email" value={editFormData.manager_email} onChange={(e) => handleEditChange('manager_email', e.target.value)}
                    className={inputCls(editErrors.manager_email)} placeholder="name@domain.com" disabled={isSubmitting} />
                  <FieldError msg={editErrors.manager_email} />
                </div>
                <div>
                  <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Phone No.</label>
                  <input type="text" value={editFormData.phone_number} onChange={(e) => handleEditChange('phone_number', e.target.value)}
                    className={inputCls(editErrors.phone_number)} placeholder="1234567891" disabled={isSubmitting} />
                  <FieldError msg={editErrors.phone_number} />
                </div>
                <div>
                  <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Role</label>
                  <select value={editFormData.role} onChange={(e) => handleEditChange('role', e.target.value)} className={inputCls(false)} disabled={isSubmitting}>
                    <option value="Manager">Manager</option>
                  </select>
                </div>
                <div>
                  <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Department</label>
                  <input type="text" value={editFormData.department} onChange={(e) => handleEditChange('department', e.target.value)}
                    onKeyDown={blockNonAlpha} className={inputCls(editErrors.department)} disabled={isSubmitting} />
                  <FieldError msg={editErrors.department} />
                  <p className={`mt-1 text-xs ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>Letters and spaces only</p>
                </div>
                <div>
                  <label className={`block mb-2 text-sm font-medium ${isDark ? 'text-blue-300' : 'text-gray-700'}`}>Status</label>
                  <div className="flex gap-4">
                    {[{ label: 'Active', val: true }, { label: 'Inactive', val: false }].map(({ label, val }) => (
                      <label key={label} className="flex items-center gap-2 cursor-pointer">
                        <input type="radio" checked={editFormData.status === val} onChange={() => handleEditChange('status', val)}
                          className={`w-4 h-4 ${val ? 'text-green-600 focus:ring-green-500' : 'text-red-600 focus:ring-red-500'}`} disabled={isSubmitting} />
                        <span className={`text-sm ${textPrimary}`}>{label}</span>
                      </label>
                    ))}
                  </div>
                  <p className={`mt-1 text-xs ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
                    {editFormData.status ? 'Manager has access to the system' : 'Manager cannot access the system'}
                  </p>
                </div>
                <div className="flex gap-3 pt-4 pb-2 sm:pb-0">
                  <button type="submit" disabled={isSubmitting}
                    className="flex items-center justify-center flex-1 gap-2 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-blue-600 rounded-lg hover:bg-blue-700 disabled:opacity-50">
                    {isSubmitting ? <><SpinnerIcon /> Saving...</> : 'Save Changes'}
                  </button>
                  <button type="button" onClick={() => setIsEditModalOpen(false)} disabled={isSubmitting}
                    className={`flex-1 py-2.5 sm:py-3 text-sm font-medium transition-colors border rounded-lg ${isDark ? 'text-white bg-gray-800 hover:bg-gray-700 border-blue-800/40' : 'text-gray-700 bg-gray-200 hover:bg-gray-300 border-gray-300'} disabled:opacity-50`}>
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* ── Delete Confirmation Modal (single) ──────────────────────────────────────────── */}
      {isDeleteModalOpen && (
        <div className={`fixed inset-0 z-50 flex items-end justify-center sm:items-center sm:p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`}
          onClick={() => !isSubmitting && setIsDeleteModalOpen(false)}>
          <div className={`w-full sm:max-w-md border ${bgModal} ${isDark ? 'border-red-700/50' : 'border-red-300'} rounded-2xl sm:rounded-2xl mb-[200px] sm:mb-0 transition-colors duration-300`}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-center pt-3 pb-1 sm:hidden">
              <div className={`w-10 h-1 ${isDark ? 'bg-gray-600' : 'bg-gray-300'} rounded-full`} />
            </div>
            <div className="p-5 sm:p-8">
              <h3 className={`flex items-center gap-2 mb-4 text-lg font-bold ${textPrimary} sm:text-2xl`}>
                <svg className={`w-5 h-5 ${isDark ? 'text-red-500' : 'text-red-600'} sm:w-6 sm:h-6`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                Confirm Delete
              </h3>
              <p className={`mb-6 text-sm ${isDark ? 'text-gray-300' : 'text-gray-600'} sm:text-base`}>
                Are you sure you want to delete{' '}
                <span className={`font-bold ${textPrimary}`}>{selectedManager?.manager_name}</span>?
                This action cannot be undone.
              </p>
              <div className="flex gap-3 pb-2 sm:pb-0">
                <button onClick={() => setIsDeleteModalOpen(false)} disabled={isSubmitting}
                  className={`flex-1 py-2.5 sm:py-3 text-sm font-medium transition-colors border rounded-lg ${isDark ? 'text-white bg-gray-800 hover:bg-gray-700 border-blue-800/40' : 'text-gray-700 bg-gray-200 hover:bg-gray-300 border-gray-300'} disabled:opacity-50`}>
                  Cancel
                </button>
                <button onClick={handleDeleteConfirm} disabled={isSubmitting}
                  className="flex items-center justify-center flex-1 gap-2 py-2.5 sm:py-3 text-sm font-medium text-white transition-colors bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50">
                  {isSubmitting ? <><SpinnerIcon /> Deleting...</> : 'Delete'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ManagerManagement;
